<template>
  <FlexColumn :space="2">
    <Label text="年齢" class="mb-1" bold />
    <FlexRow>
      <NumberField :value="value.lower" label="" placeholder="下限" suffix="歳" simple style="width: 64px" class="mt-0 pt-0" @input="handleLower" />
      <NumberField :value="value.upper" label="" placeholder="上限" suffix="歳" simple style="width: 64px" class="mt-0 pt-0" @input="handleUpper" />
    </FlexRow>
  </FlexColumn>
</template>

<script>
import FlexRow from "../atoms/FlexRow";
import NumberField from "./NumberField";
import Label from '../atoms/Label'
import FlexColumn from '../atoms/FlexColumn'
export default {
  name: "ApplicantSearchAgeField",
  components: { FlexColumn, Label, NumberField, FlexRow},
  props: {
    value: {
      type: Object
    }
  },
  methods: {
    handleLower(value) {
      this.$emit("input", {
        lower: value,
        upper: this.value.upper
      })
    },
    handleUpper(value) {
      this.$emit("input", {
        lower: this.value.lower,
        upper: value
      })
    }
  }
}
</script>

<style scoped>

</style>